import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { type SignUpModalAction } from '@/components/DownloadAppModal/DownloadAppModal';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { getRouteName } from '@/modules/activityTracker/referers';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useSignupModalTracking() {
  const pathname = usePathname();
  const pageType = getRouteName(pathname);
  const [, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  useEffect(() => {
    sendActivityTrackerEvent(ActivityTrackerEventType.SIGNUP_MODAL_VIEW, {
      pageType,
      schemaVersion: '1.0',
    });
  }, []);

  function sendSignupModalActionEvent(actionType: SignUpModalAction) {
    sendActivityTrackerEvent(ActivityTrackerEventType.SIGNUP_MODAL_ACTION, {
      pageType,
      actionType,
      schemaVersion: '1.0',
    });
  }

  return { sendSignupModalActionEvent };
}
